import 'babel-polyfill'

// import Vue from "vue"
import SwHic, {Vue, App} from "sw-hic"
import "sw-hic/sw-hic.css"
import SwPatient from '@sunway/patient'
import store from '@/common/store'
// import app from './App.vue'
import router from '@/common/router'

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development') {
  // 引入mockjs
  // require('./common/mock.js')
}
Vue.use(SwHic)
Vue.use(SwPatient)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
